import db from '@/db';

// Eventos granulares de cross-sell (Fase 5)
// event: 'shown' | 'accepted' | 'declined'
export async function logCrossSellEvent(event, triggerItemId, suggestionItemId) {
  try {
    await db.crossSellEvents.add({
      event,
      triggerItemId,
      suggestionItemId,
      timestamp: new Date().toISOString(),
    });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn('Falha ao registrar evento cross-sell:', err);
  }
}

export async function getCrossSellStats(startDateISO) {
  const all = await db.crossSellEvents.toArray();
  const filtered = startDateISO ? all.filter((e) => e.timestamp >= startDateISO) : all;
  const shown = filtered.filter((e) => e.event === 'shown').length;
  const accepted = filtered.filter((e) => e.event === 'accepted').length;
  const declined = filtered.filter((e) => e.event === 'declined').length;
  const rate = shown > 0 ? (accepted / shown) * 100 : 0;
  return { shown, accepted, declined, rate };
}
